import React from "react";
import "tippy.js/dist/tippy.css";
import IconButton from "./IconButton";
import LightButton from './LightButton';

const EditButton = ({show = true, onClick}) => {

    return (
        <>
            <LightButton
                show={show}
                onClick={onClick}
            >Zmień</LightButton>
        </>
    );
};


export default EditButton;